export default {
  /* */
  UPDATE: ' accountWallet/UPDATE',
  ADD_PRODUCT_TO_CART: 'accountWallet/ADD_PRODUCT_TO_CART',
  ADD_TRANSACTION: 'accountWallet/ADD_TRANSACTION',
  /* */
  gql: {
    GET_ACCOUNT_WALLET_REFILLS: `
      query GetAccountWalletRefills(
          $golfId: String!
        ) {
          getAccountWalletRefills(
            golfId: $golfId
          ) {
            id
            name
            paidAmount
            refilledAmount
            bonusAmount
          }
        }
    `,
    CREATE_ACCOUNT_WALLET_OPERATION: `
      mutation CreateAccountWalletOperation(
        $golfId: String!
        $accountId: String!
        $product: AccountWalletRefillInput!
        $creditCardTransaction: PayboxTransaction!
      ) {
        createAccountWalletOperation(
          golfId: $golfId
          accountId: $accountId
          product: $product
          creditCardTransaction: $creditCardTransaction
        ) {
          transaction {
            card
            amount
            type
            brand
            callNo
            country
            creditCardId
            transactionNo
          }
        }
      }
    `,
    GET: `
      query GetAccountWallet(
        $golfId: String!
        $accountId: String!
      ) {
        getAccountWallet(
          golfId: $golfId
          accountId: $accountId
        ) {
          id
          balance
          creditLimit
        }
      }
    `,
  },
};
